"use client";

import { cn } from "@/lib/utils";
import { Minus, Plus } from "react-feather";

export type ZoomControlsProps = {
  zoomIn: () => void;
  zoomOut: () => void;
};

const ZoomControls = ({ zoomIn, zoomOut }: ZoomControlsProps) => {
  return (
    <div className="pointer-events-auto ml-auto flex flex-col gap-[1px] drop-shadow-lg lg:mt-auto">
      <div
        onClick={() => zoomIn()}
        className={cn(
          "group z-[1] flex border border-transparent bg-white px-2 hover:bg-primary-100 active:border-primary-300 active:bg-primary-200",
          "aspect-[40/40] max-h-[40px] min-h-[40px] min-w-[40px] max-w-[40px] cursor-pointer",
          "items-center justify-center gap-2 rounded-[4px]"
        )}
      >
        <Plus
          className="flex h-full w-full text-neutral-400 group-hover:text-neutral-600"
          size={24}
        />
      </div>
      <div
        onClick={() => zoomOut()}
        className={cn(
          "group z-[1] flex border border-transparent bg-white px-2 hover:bg-primary-100 active:border-primary-300 active:bg-primary-200",
          "aspect-[40/40] max-h-[40px] min-h-[40px] min-w-[40px] max-w-[40px] cursor-pointer",
          "items-center justify-center gap-2 rounded-[4px]"
        )}
      >
        <Minus
          className="flex h-full w-full text-neutral-400 group-hover:text-neutral-600"
          size={24}
        />
      </div>
    </div>
  );
};

export default ZoomControls;
